import { AfterContentInit, AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, NgZone, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { count, from, map, of, reduce } from 'rxjs';
import { FileServiceService } from '../service/file-service.service';
import { FileCaptureService } from 'app/service/file-capture.service';
import { environment } from 'environments/environment';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-review-files',
  changeDetection: ChangeDetectionStrategy.Default,
  templateUrl: './review-files.component.html',
  styleUrls: ['./review-files.component.css']
})
export class ReviewFilesComponent implements OnInit {
  files: any;
  totalFilesSize: number = 0;
  isDisabled: boolean;
  openUploadModal: boolean = false;
  uploadedFiles: File[] | null = null;
  fileSubmitted: boolean = false;
  showFileUploadError: boolean;

  constructor(
    private route: Router,
    public service: FileServiceService,
    private fcservice: FileCaptureService,
    private cdr: ChangeDetectorRef,
    private zone: NgZone,
    private ngxspinner : NgxSpinnerService
  ) {
   
  }

ngOnInit() {
  this.service.setPageVisited('review-files');
  const allCachedFiles = this.service.getCache('files');
  if (allCachedFiles) {
    const currentRefId = this.service.getCache('referenceId');
    this.files = currentRefId
      ? allCachedFiles.filter((f: any) => !f.referenceId || f.referenceId === currentRefId)
      : allCachedFiles;
    from(this.files.map((x: any) => x.fileSize))
      .pipe(reduce((a: any, b: any) => a + b, 0))
      .subscribe(x => this.totalFilesSize = x);
    this.service.referenceFileDetails.files = this.files;
    this.uploadedFiles = this.fcservice.fileArray;

    this.isDisabled = this.files == null || this.files.length < 1;
    }
  }

  reviewAndScan() {
    setTimeout(() => {
      const attachment = {
        referenceId: '',
        attachmentKeyList: []
      };
      attachment.referenceId = this.service.getCache('referenceId');
      attachment.attachmentKeyList = this.files.map(x => x.attachmentKey);
      if (attachment.attachmentKeyList.length > 0) {
        this.fcservice.ReviewAndScanAttachmnents(attachment).subscribe(
          (result: boolean) => {
          },
          (error: any) => {
          }
        );
      }
    }, 3000);
  }

  next() {
    this.route.navigate(['initiate-download']);
  }

  removeFile(index: number) {
    this.totalFilesSize = this.totalFilesSize - this.files[index].fileSize;
    this.files.splice(index, 1);
    this.service.setCacheForitems([{ id: "files", value: this.files }]);
    const newFiles = this.files.filter(x => x.isUpload == 1)
    if (newFiles == 0 && this.files.length > 0) {
      this.isDisabled = false;
    }
  }

  addNewFile() {
    this.route.navigate(['file-upload']);
  }

  back() {
    this.route.navigate(['file-upload']);
  }
  
  onSubmit() {
    const newFiles = this.files.filter(x => x.isUpload == 1);
    if (newFiles.length > 0) {
      this.openUploadModal = true;
      return;
    }
    this.submitFinalDocument();
  }

  handleUploadCompleted(event: any) {
    this.openUploadModal = false;

    const successfulFiles = event.files.filter((x: any) =>
      x.attachmentKey &&
      x.percentage !== 500 &&
      x.percentage !== 600 &&
      x.uploadFailed !== true &&
      x.failureToUpload !== true &&
      x.scanStatus !== 99
    );

    this.files = successfulFiles;
    this.service.referenceFileDetails.files = successfulFiles;
    this.service.setCacheForitems([{ id: 'files', value: successfulFiles }]);

    if (successfulFiles.length > 0) {
      this.showFileUploadError = false;
      this.submitFinalDocument();
      return;
    }

    this.showFileUploadError = true;
    this.isDisabled = false;
  }

  submitFinalDocument() {
    const validFiles = this.files.filter((x: any) =>
      x.attachmentKey &&
      x.isVisible !== x.attachmentKey + '_99' &&
      x.uploadFailed !== true &&
      x.failureToUpload !== true &&
      x.scanStatus !== 99 &&
      x.percentage !== 500 &&
      x.percentage !== 600
    );

    const data = {
      BusinessName: this.service.referenceFileDetails.businessName,
      ContactName: this.service.referenceFileDetails.contactName,
      ContactPhone: this.service.referenceFileDetails.contactPhone,
      ContactEmail: this.service.referenceFileDetails.contactEmail,
      ReferenceId: this.service.referenceFileDetails.referenceId,
      CaseActivityKey: this.service.referenceFileDetails.caseActivityKey,
      ActiveAttachmentKey: validFiles.map((x: any) => x.attachmentKey),
      TimeZoneUtcDifference: new Date().getTimezoneOffset()
    };

    if (!data.ActiveAttachmentKey.length) {
      this.showFileUploadError = true;
      this.isDisabled = false;
      return;
    }

    this.ngxspinner.show();
    this.fcservice.submitDocument(data).subscribe(
      (res) => {
        this.fileSubmitted = true;
        this.ngxspinner.hide();
        if (res) {
          const sessionId = window.sessionStorage.getItem(this.fcservice.SESSION_KEY) || '';
          const payorKey = Number(window.sessionStorage.getItem(this.fcservice.PAYOR_KEY) || 0);
          if (sessionId && payorKey > 0 && data.ReferenceId) {
            this.fcservice.releaseReferenceLock(data.ReferenceId, payorKey, sessionId).subscribe();
            window.sessionStorage.removeItem(this.fcservice.SESSION_KEY);
          }

          this.service.setCacheForitems([
            { id: 'attachmentSaved', value: null },
            { id: 'caseActivityKey', value: null },
            { id: 'attachmentSavedForRef', value: null },
            { id: 'files', value: null }
          ]);

          this.fcservice.fileArray = [];
          this.route.navigate(['confirmation']);
        }
      },
      () => this.ngxspinner.hide()
    );
  }
  closeUploadPopup() {
    this.openUploadModal = false;
  }
}
